import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import clsx from "clsx";
import { useRouter } from "next/router";
import { safeLocalStorage } from "~/utils/safeStorage";
import { declOfNum, getFilterUrl } from "../../../../../utils";
import { getFilter } from "../../../../../redux/action-creaters/filter";
import styles from "./index.module.scss";
import {
  filterProps,
  filterPropsTop,
  filterSliderProps,
} from "../../../../../utils/constants";
import Loader from "../../../../common/loader";
import Button from "../../../../common/button";
import Item from "./item";

export default function Filter({
  sectionPageUrl,
  onChangeUrl,
  productCount = 0,
}) {
  const dispatch = useDispatch();
  const { filter, params, isFilterLoaded } = useSelector(
    (state) => state.filter,
  );
  const router = useRouter();
  useEffect(() => {
    dispatch(getFilter(Boolean(router.query.reset)));
  }, [params]);

  const paramsFormat = useMemo(() => {
    return params;
    // eslint-disable-next-line no-unreachable
    const paramsFormated = {};
    Object.keys(params).forEach((key) => {
      if (key.indexOf("-from") > -1) {
        paramsFormated[key.replace("-from", "")] = `from-${params[key]}`;
      } else if (key.indexOf("-to") > -1) {
        if (paramsFormated[key.replace("-to", "")]) {
          paramsFormated[key.replace("-to", "")] += `-to-${params[key]}`;
        } else {
          paramsFormated[key.replace("-to", "")] = `to-${params[key]}`;
        }
      } else {
        paramsFormated[key] = params[key];
      }
    });
    // eslint-disable-next-line no-unreachable
    return paramsFormated;
  }, [params]);

  const [isChanged, setIsChanged] = useState(false);

  const onChangeSlider = (itemCode, { min, max }) => {
    if (!isChanged) {
      return;
    }
    setIsChanged(false);

    if (min && +min < +filter.filtersCounts[itemCode].min) {
      // eslint-disable-next-line no-param-reassign
      min = filter.filtersCounts[itemCode].min;
      // eslint-disable-next-line no-use-before-define
      setChangedValues((items) => {
        return {
          ...items,
          [itemCode]: { ...items[itemCode], min },
        };
      });
    }
    if (min && +min >= +filter.filtersCounts[itemCode].max) {
      // eslint-disable-next-line no-param-reassign
      min = filter.filtersCounts[itemCode].max;
      // eslint-disable-next-line no-use-before-define
      setChangedValues((items) => {
        return {
          ...items,
          [itemCode]: { ...items[itemCode], min },
        };
      });
    }
    if (max && +max > +filter.filtersCounts[itemCode].max) {
      // eslint-disable-next-line no-param-reassign
      max = filter.filtersCounts[itemCode].max;
      // eslint-disable-next-line no-use-before-define
      setChangedValues((items) => {
        return {
          ...items,
          [itemCode]: { ...items[itemCode], max },
        };
      });
    }

    const value = [];
    if (min && min > filter.filtersCounts[itemCode].min) {
      value.push("from", min);
    } else if (min) {
      // eslint-disable-next-line no-use-before-define
      onChangeSliderValue(itemCode, { min: undefined });
    }
    if (
      max &&
      max < filter.filtersCounts[itemCode].max &&
      max > filter.filtersCounts[itemCode].min
    ) {
      value.push("to", max);
    } else if (max) {
      // eslint-disable-next-line no-use-before-define
      onChangeSliderValue(itemCode, { max: undefined });
    }

    onChangeUrl(
      getFilterUrl(sectionPageUrl, {
        ...paramsFormat,
        [itemCode]: value,
      }),
    );
  };

  const [changedValues, setChangedValues] = useState({});

  const onChangeSliderValue = (itemCode, newValues) => {
    if (
      // eslint-disable-next-line eqeqeq
      changedValues[itemCode]?.min == newValues.min &&
      // eslint-disable-next-line eqeqeq
      changedValues[itemCode]?.max == newValues.max
    ) {
      return;
    }
    setIsChanged(true);
    setChangedValues((items) => {
      return {
        ...items,
        [itemCode]: { ...items[itemCode], ...newValues },
      };
    });
  };

  const onChange = (filterCode, valueCode) => {
    const url = getFilterUrl(sectionPageUrl, paramsFormat, {
      [filterCode]: valueCode,
    });
    onChangeUrl(url);
  };

  const filterStructTop = useMemo(() => {
    const items = [];

    if (filter.filtersCounts) {
      filterPropsTop.forEach((key) => {
        if (!filter.filtersCounts[key]) {
          return;
        }
        if (
          !params.price &&
          filterSliderProps.includes(key) &&
          productCount <= 1
        ) {
          return;
        }

        items.push([key, filter.filtersCounts[key]]);
      });
    }

    return items;
  }, [filter]);

  const filterStruct = useMemo(() => {
    const items = [];
    if (filter.filtersCounts) {
      filterProps.forEach((key) => {
        if (key === "elektrika_v_komplekte" && !params.kuzov) {
          return;
        }
        if (!filter.filtersCounts[key]) {
          return;
        }
        if (
          !params.price &&
          filterSliderProps.includes(key) &&
          productCount <= 1
        ) {
          return;
        }

        items.push([key, filter.filtersCounts[key]]);
      });
    }

    return items;
  }, [filter]);

  const totalCheckedCnt = useMemo(() => {
    return Object.values(params).length;
  }, [params]);
  const { count } = useSelector((state) => state.section);

  useEffect(() => {
    if (params.price) {
      const price = {};
      if (params.price.includes("from")) {
        price.min = params.price?.[1];
      }

      if (params.price.includes("to")) {
        price.max = params.price?.includes("from")
          ? params.price[3]
          : params.price[1];
      }

      setChangedValues({
        ...changedValues,
        price,
      });
    }
  }, [params]);

  return (
    <>
      {!isFilterLoaded && (
        <div className={styles.Loader}>
          <Loader />
        </div>
      )}
      {isFilterLoaded && (
        <>
          {params?.kuzov?.[0] && filterStructTop.length > 0 && (
            <div className={clsx(styles.Filter, styles.FilterTop)}>
              {filterStructTop.map(([filterCode, filterValues]) => (
                <Item
                  key={filterCode}
                  changedValues={changedValues}
                  filterCode={filterCode}
                  filterValues={filterValues}
                  onChange={onChange}
                  onChangeSlider={onChangeSlider}
                  onChangeSliderValue={onChangeSliderValue}
                />
              ))}
            </div>
          )}
          <div className={styles.Filter}>
            {filterStruct.map(([filterCode, filterValues]) => (
              <Item
                key={filterCode}
                changedValues={changedValues}
                filterCode={filterCode}
                filterValues={filterValues}
                onChange={onChange}
                onChangeSlider={onChangeSlider}
                onChangeSliderValue={onChangeSliderValue}
              />
            ))}

            {totalCheckedCnt > 0 && (
              <>
                <div className={styles.Reset}>
                  <Button
                    after={
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 1L1 11M1 1L11 11"
                          stroke="#6C737F"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    }
                    label="Сбросить"
                    test="filterResetButton"
                    type="none"
                    onClick={() => {
                      safeLocalStorage.setItem("mark_", "");
                      safeLocalStorage.setItem("model_", "");
                      safeLocalStorage.setItem("type_", "");
                      onChangeUrl(sectionPageUrl);
                    }}
                  />
                </div>
                <div className={styles.Show}>
                  <Button
                    label={`Показать ${declOfNum(count, ["товар", "товара", "товаров"])}`}
                    onClick={() => {
                      const element = document.getElementById("catalog");
                      const elementPosition =
                        element.getBoundingClientRect().top +
                        window.pageYOffset;
                      const offsetPosition = elementPosition - 100; // отступ 100px сверху

                      window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                      });
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
}
